import React, { useEffect, useState } from "react";
import {Card,Collapse,Typography,Input,Row,Col,Button,Space,message,Spin,Form,} from "antd";
import {SendOutlined,CommentOutlined,DownOutlined,RightOutlined,} from "@ant-design/icons";
import _BankerService from "../../modules/BankerService";
import { COMMON_ERROR_MSG } from "../../constants/constants";
import _commonService from "../../modules/commonService";
import { LoanOfficerReviewStatusId, PRIVATE_WEALTH_ADVISOR_ROLE,SENIOR_PRIVATE_BANKER_ROLE,UnderReviewStatusId } from "../../constants/DataConstants";
import _NewapplicationService from "../../modules/NewapplicationService";
import FormItemTextArea from "../../components/FormItems/FormItemTextArea";
import ButtonComponent from "../../components/Button/Button";

const { Panel } = Collapse;
const { Text } = Typography;

const CommentSection = ({ CommentSectionName, applicationstatusid, applicantDetails, ApplicationObjId: ApplicationObjIdProp }) => {
    const [comments, setComments] = useState([]);
    const [loading, setLoading] = useState(false);
    const [form] = Form.useForm();

    const ApplicationObjId = parseInt(ApplicationObjIdProp);
    const bankerIdRaw = localStorage.getItem("BankerId");
    const BankerId = bankerIdRaw ? parseInt(bankerIdRaw) : null;
    const isLoanOfficer = JSON.parse(localStorage.getItem("IsLoanofficerFlag"));
    const ApplicantName = localStorage.getItem("ApplicantName");
    const userRole = localStorage.getItem("userRole");
    const isPrivateWealthAdvisor = userRole === PRIVATE_WEALTH_ADVISOR_ROLE;
    const RoleId = Number(localStorage.getItem("RoleId") ?? 0);
    const isSeniorPrivateBanker = localStorage.getItem("userRole") === SENIOR_PRIVATE_BANKER_ROLE
    

    const bankerLabel =
        userRole === "Senior Banker"
            ? "Senior Banker"
            : userRole === "Portfolio Banker"
                ? "Portfolio Banker"
                : userRole === "Underwriter Banker"
                    ? "Underwriter Banker"
                    : "B.O";

    useEffect(() => {
        if (isPrivateWealthAdvisor) {
            return;
        }

        getApplicationReviewComment();
    }, [isPrivateWealthAdvisor]);

    const getApplicationReviewComment = async () => {
        try {
            setLoading(true);
            const res = await _NewapplicationService.getReviewCommentByApplicationId(ApplicationObjId);
            // debugger
            if (res.data.IsSuccess) {
                const filteredRemarks = res.data.Obj?.filter((item) =>
                    (item.ReviewCommentsBy_BankerId && item.ReviewCommentsBy_BankerId > 0) ||
                    (item.ReviewCommentsBy_LoanOfficerId && item.ReviewCommentsBy_LoanOfficerId > 0) ||
                    (item.Comments != "")
                );
                setComments(filteredRemarks || []);
            } else {
                message.error(res.data.Message || COMMON_ERROR_MSG);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    console.log(localStorage.getItem("ApplicantName"));

    const handleAddComment = async (values) => {
        const { comment } = values;

        const reqObj = {
            Section: CommentSectionName,
            ApplicationId: ApplicationObjId,
            // Remarks: remarks.trim(),
            Comments: comment.trim(),
            // LoanOfficer table is going away -- Loan Officer's identity is now Banker.Id too,
            // so route it into whichever review-comment column matches the active role.
            ReviewCommentsBy_BankerId: isLoanOfficer ? null : (BankerId || null),
            ReviewCommentsBy_LoanOfficerId: isLoanOfficer ? (BankerId || null) : null,
            ApplicationStatusId: isLoanOfficer
                ? LoanOfficerReviewStatusId
                : applicationstatusid || UnderReviewStatusId,
            RoleId: RoleId || null,
        };

        try {
            setLoading(true);
            const res = await _BankerService.addApplicationReviewComment(reqObj);
            if (res.data.IsSuccess) {
                message.success(res.data.Message);
                getApplicationReviewComment();
                form.resetFields();
            } else {
                message.error(res.data.Message || COMMON_ERROR_MSG);
            }
        } catch (err) {
            console.error(err);
            message.error(COMMON_ERROR_MSG);
        } finally {
            setLoading(false);
        }
    };

    return (
        isPrivateWealthAdvisor ? null : (
            <Spin spinning={loading}>
                <Card
                    // className="commentSectionCard"
                    className="card-section mt20 comment-section-card"
                    title={
                        <Space>
                            <CommentOutlined />
                            <Text strong>Comments</Text>
                        </Space>
                    }

                >

                {comments
                        ?.filter((comment) => comment.Section === CommentSectionName).length > 0 && (
                            <Collapse
                                accordion
                                collapsible="icon"
                                expandIcon={({ isActive }) =>
                                    isActive ? <DownOutlined className="collapse-expand-icon" /> : <RightOutlined className="collapse-expand-icon" />
                                }
                                bordered={false}
                                className="card-section"
                            >
                                {comments
                                    ?.filter((comment) => comment.Section === CommentSectionName)
                                    .map((comment) => (
                                        <Panel
                                            key={comment.Id}
                                            header={
                                                <Row justify="space-between" style={{ width: "100%" }}>
                                                    <Col>
                                                        <Text strong>
                                                            {/* {
                                                            comment.ReviewCommentsBy_BankerId == null && comment.ReviewCommentsBy_LoanOfficerId == null
                                                                ? `App | ${ApplicantName}`
                                                                : comment.ReviewCommentsBy_BankerId > 0
                                                                    ? `B.O | ${comment.ReviewCommentsBankerName}`
                                                                    : `Credit | ${comment.ReviewCommentsLoanOfficerName}`
                                                        } */}
                                                            {
                                                                comment.ReviewCommentsBy_BankerId == null && comment.ReviewCommentsBy_LoanOfficerId == null
                                                                    ? `App | ${ApplicantName}`
                                                                    : comment.ReviewCommentsBy_BankerId > 0
                                                                        ? `${bankerLabel} | ${comment.ReviewCommentsBankerName}`
                                                                        : `Credit | ${comment.ReviewCommentsLoanOfficerName}`
                                                            }
                                                            {/* |{" "}
                                                {comment.ReviewCommentsBy_BankerId > 0
                                                    ? comment.ReviewCommentsBankerName
                                                    : comment.ReviewCommentsLoanOfficerName} */}
                                                        </Text>
                                                    </Col>
                                                    <Col>
                                                        <Text type="secondary" style={{ fontSize: 12 }}>
                                                            {comment.CreatedDate
                                                                ? _commonService.formatDateTimeAMPM(comment.CreatedDate)
                                                                : "N/A"}
                                                        </Text>
                                                    </Col>
                                                </Row>
                                            }
                                        >
                                            {/* <div>
                                    <Text><b>Remarks:</b> {comment.Remarks}</Text>
                                </div> */}
                                            <div>
                                                <Text><b>Comment:</b> {comment.Comments}</Text>
                                            </div>
                                        </Panel>
                                    ))}
                            </Collapse>
                        )}

                    {/* Comment Input Form */}
                    <Form
                        form={form}
                        layout="vertical"
                        onFinish={handleAddComment}
                        initialValues={{ comment: "", remarks: "" }}
                    >
                        <Row gutter={16} style={{ marginTop: 16, borderTop: "2px solid rgba(244, 244, 245, 0.10)", paddingTop: 12 }}>
                            {/* <Col span={8}>
                            <Form.Item
                                name="remarks"
                                rules={[{ required: true, message: "Remarks are required" }]}
                            >
                                <Input
                                    placeholder="Enter your remarks *"
                                    disabled={applicationstatusid === 8 || applicationstatusid === 9}
                                />
                            </Form.Item>
                        </Col> */}
                            <Col span={22}>
                                {/* <Form.Item
                                name="comment"
                                rules={[{ required: true, message: "Comment is required" }]}
                            >
                                <Input.TextArea
                                    placeholder="comments *"
                                    autoSize={{ minRows: 2, maxRows: 6 }}
                                    disabled={applicationstatusid === 8 || applicationstatusid === 9}
                                />
                            </Form.Item> */}

                                <FormItemTextArea
                                    name="comment"
                                    placeholder="comments *"
                                    autoSize={{ minRows: 2, maxRows: 6 }}
                                    disabled={isSeniorPrivateBanker ? (applicationstatusid == 11 || applicationstatusid == 13 || applicationstatusid == 14 || applicationstatusid == 16) : ((applicantDetails?.IsClear_Completed == true && applicantDetails?.IsApplicationApproved == true) || applicationstatusid === 11 || applicationstatusid === 13 || applicationstatusid === 14 || applicationstatusid === 16)}
                                    rules={[{ required: true, message: "Comment is required" }]}
                                />
                            </Col>
                            <Col span={2} style={{ display: "flex", alignItems: "end" }}>
                                <Form.Item>
                                    {/* <Button
                                  className="send-btn"
                                    type="primary"
                                    htmlType="submit"
                                    disabled={applicationstatusid === 8 || applicationstatusid === 9}
                                    style={{padding:"18px 17px"}}
                                >
                                    <SendOutlined />
                                </Button> */}

                                    <ButtonComponent
                                        className="send-btn"
                                        type="primary"
                                        htmlType="submit"
                                        disabled={isSeniorPrivateBanker ? (applicationstatusid == 11 || applicationstatusid == 13 || applicationstatusid == 14 || applicationstatusid == 16) : ((applicantDetails?.IsClear_Completed == true && applicantDetails?.IsApplicationApproved == true) || applicationstatusid === 11 || applicationstatusid === 13 || applicationstatusid === 14 || applicationstatusid === 16)}
                                        style={{ padding: "18px 17px" }}
                                        icon={<SendOutlined />}
                                        iconPosition="left"
                                        text=""
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                </Card>
            </Spin>
        )
    );
};

export default CommentSection;
